import { render, staticRenderFns } from "./contactAppConfigForm.vue?vue&type=template&id=a5bd321e&scoped=true&"
import script from "./contactAppConfigForm.vue?vue&type=script&lang=babel&"
export * from "./contactAppConfigForm.vue?vue&type=script&lang=babel&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a5bd321e",
  null
  
)

export default component.exports